import React from 'react'

const Container = ({ className, children }) => (
  <div className={`w-full px-4 md:px-0 md:mx-auto md:w-11/12 ${className || ''}`}>
    {children}
  </div>
)

export default Container
